import { computed } from "vue";
import { useLocationStore } from "~/stores/location";

/**
 * Composable that provides access to location state from the Pinia store.
 * Location is persisted across navigation and stored in localStorage.
 */
export function useGeolocation() {
  const store = useLocationStore();

  return {
    approxRegion: computed(() => store.approxRegion),
    detectedLat: computed(() => store.latitude),
    detectedLon: computed(() => store.longitude),
    detectedCity: computed(() => store.city),
    detectedCountry: computed(() => store.country),
    latitude: computed(() => store.latitude),
    longitude: computed(() => store.longitude),
    requestGeolocation: (options?: { fallbackToIp?: boolean }) =>
      store.requestGeolocation(options),
    fallbackDetectRegion: () => store.fallbackDetectRegion(),
    declineLocation: () => store.declineLocation(),
  } as const;
}
